import { Alert, Button } from 'antd';
import classNames from 'classnames';
import { t } from 'ttag';
import { infoIconV2 } from './assets';
import type { DiagnosticYieldAlertProps } from './types';
import './diagnosticYieldAlert.scss';

/**
 * Default no-op handler standing in for an absent optional callback prop of the diagnostic yield alert. Accepts no arguments and performs no work.
 *
 * @returns Nothing.
 */
const NOOP = () => {};

const DiagnosticYieldAlert = ({
  isInboxTab = false,
  afterClose = NOOP,
}: DiagnosticYieldAlertProps) => {
  /**
   * Opens the diagnostic yield page from the alert. Calls window.open on the /diagnostic-yield route so it loads in a new browsing context.
   *
   * @returns Nothing.
   */
  const handleClick = () => {
    window.open('/diagnostic-yield');
  };

  return (
    <Alert
      className={classNames('diagnostic-yield', isInboxTab && 'custom-border-radius')}
      aria-label={
        isInboxTab
          ? t`If you didn't find what you are looking for, studies show that chances of identifying arrhythmia is much higher in 10 day studies compared to shorter ones.`
          : t`Studies show that diagnostic yield is significantly improved with studies that are at least 10 days long.`
      }
      message={
        <div className="text">
          {isInboxTab
            ? t`If you didn't find what you are looking for, studies show that chances of identifying arrhythmia is much higher in 10 day studies compared to shorter ones.`
            : t`Studies show that diagnostic yield is significantly improved with studies that are at least 10 days long.`}{' '}
          <Button type="link" onClick={handleClick}>{t`Click to learn more`}</Button>
        </div>
      }
      type="info"
      showIcon
      icon={<img src={infoIconV2} alt="" />}
      afterClose={afterClose}
      closable
    />
  );
};

export default DiagnosticYieldAlert;
